import { poiLabelIcon } from './makiPaths';
import { placeMarkerColors } from './placeType';
import type { PointOfInterestPlace } from './pointOfInterest';

const SVG_NS = 'http://www.w3.org/2000/svg';
/** Same canvas as the selected location mark, so the ground dot lands the same way. */
const PIN_WIDTH = 32;
const PIN_HEIGHT = 44;
const GROUND_DOT = '#0B2936';
const HEAD_STROKE = '#fff';

/**
 * The selected-place pin. The head is always a circle in that place's map color,
 * with the white glyph inside. Airports keep the circle here: the tile plate is
 * a basemap treatment, and the pin matches the location mark's round head.
 */
export function placePinElement(place: PointOfInterestPlace): HTMLElement {
  const { background, foreground } = placeMarkerColors(place.maki, place.placeClass);
  const icon = poiLabelIcon(place.maki);

  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('width', String(PIN_WIDTH));
  svg.setAttribute('height', String(PIN_HEIGHT));
  svg.setAttribute('viewBox', `0 0 ${PIN_WIDTH} ${PIN_HEIGHT}`);
  svg.setAttribute('aria-hidden', 'true');
  svg.style.display = 'block';

  svg.append(circle('16', '16', '15', background, HEAD_STROKE, '2'));
  if (icon.glyph) {
    const group = document.createElementNS(SVG_NS, 'g');
    group.setAttribute('transform', 'translate(6 6)');
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', icon.glyph);
    path.setAttribute('fill', foreground);
    if (icon.transform) path.setAttribute('transform', icon.transform);
    group.append(path);
    svg.append(group);
  }
  svg.append(circle('16', '40', '4', GROUND_DOT));

  // Mapbox's marker takes an HTMLElement. An SVG root is not one.
  const element = document.createElement('div');
  element.setAttribute('aria-label', place.name);
  element.style.width = `${PIN_WIDTH}px`;
  element.style.height = `${PIN_HEIGHT}px`;
  element.style.pointerEvents = 'none';
  element.style.lineHeight = '0';
  element.append(svg);
  return element;
}

function circle(
  cx: string,
  cy: string,
  r: string,
  fill: string,
  stroke?: string,
  strokeWidth?: string,
): SVGCircleElement {
  const node = document.createElementNS(SVG_NS, 'circle');
  node.setAttribute('cx', cx);
  node.setAttribute('cy', cy);
  node.setAttribute('r', r);
  node.setAttribute('fill', fill);
  if (stroke) node.setAttribute('stroke', stroke);
  if (strokeWidth) node.setAttribute('stroke-width', strokeWidth);
  return node;
}
